/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { CategoriesWrapper, Category } from './component.styled';

const Categories = ({ categories, updateCategory, activeCategory }) => {
  return (
    <CategoriesWrapper>
      {categories.map(({ id, category_name }) => (
        <Category className={activeCategory === id ? 'active' : ''} onClick={() => updateCategory(id)} key={id}>
          {category_name}
        </Category>
      ))}
    </CategoriesWrapper>
  );
};

Categories.propTypes = {
  activeCategory: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateCategory: PropTypes.func.isRequired,
};

export default Categories;
